import { IMedicationCoSoItemRequest } from '../../models/request/y-te/yTeRequests';
import { medication } from '../../models/response/y-te/medication';
import { apiClient } from '../apiClient';
import { BaseCRUDApi } from '../baseCRUDApi';

export const API_MEDICATION_PATH = 'medication';

class MedicationApi extends BaseCRUDApi<medication> {
	// eslint-disable-next-line @typescript-eslint/no-useless-constructor
	constructor(path: string) {
		super(path);
	}
	/** Toàn bộ danh mục thuốc + cờ `da_dang_ky` của cơ sở → dùng cho trang cấu hình */
	SelectAllCheckDangKy(dm_coso_id: number) {
		return apiClient.get(`${API_MEDICATION_PATH}/check_dang_ky/${dm_coso_id}`);
	}
	/** Chỉ các thuốc đã đăng ký ở cơ sở → dùng cho combobox */
	SelectByCoSo(dm_coso_id: number) {
		return apiClient.get(`${API_MEDICATION_PATH}/select_by_coso/${dm_coso_id}`);
	}
	InsertMultiple(request: IMedicationCoSoItemRequest) {
		return apiClient.post(`${API_MEDICATION_PATH}/insert-multiple`, request);
	}
}
export const medicationApi = new MedicationApi(API_MEDICATION_PATH);
